/**
 * @fileoverview POSTWS handler for the "/apps/:app_group_id/user_imports/:import_id/validate" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryPostWebsocketAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdUserImportsImportIdValidate } from "./constants";
import type {
  PostwsAppsAppGroupIdUserImportsImportIdValidatePayload,
  PostwsAppsAppGroupIdUserImportsImportIdValidateProps,
} from "./types";
import { isPostwsAppsAppGroupIdUserImportsImportIdValidateResult } from "./validators";

export const postwsAppsAppGroupIdUserImportsImportIdValidate = reactQueryPostWebsocketAdapter(
  appsAppGroupIdUserImportsImportIdValidate,
  (
    signal,
    { timeout, jobToken, estimated, appGroupId, importId }: PostwsAppsAppGroupIdUserImportsImportIdValidateProps
  ): Promise<{}> => {
    const payload: PostwsAppsAppGroupIdUserImportsImportIdValidatePayload = {
      timeout,
      job_token: jobToken,
      estimated,
    };

    return fetch(`/apps/${appGroupId}/user_imports/${importId}/validate`, "POST", payload, { signal });
  },
  isPostwsAppsAppGroupIdUserImportsImportIdValidateResult
);
